import { CommonModule, ViewportScroller } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { FeatherIconsComponent } from '../feather-icons/feather-icons.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tap-to-top',
  imports: [CommonModule, FeatherIconsComponent],
  templateUrl: './tap-to-top.component.html',
})
export class TapToTopComponent {
  public show: boolean = false;

  constructor(private readonly viewScroller: ViewportScroller, private readonly router: Router) {
    this.router.events.subscribe((val) => {
      this.tapToTop();
    });
  }

  // @HostListener Decorator
  @HostListener('window:scroll', [])
  onWindowScroll() {
    let number =
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (number > 600) {
      this.show = true;
    } else {
      this.show = false;
    }
  }

  tapToTop() {
    this.viewScroller.scrollToPosition([0, 0]);
  }
}
